export enum DataType {
  STATIC = 'sta',
  DYNAMIC = 'dyn',
  REALTIME = 'real_time'
}
